// Window events the app shell fires so the three-pane layout can bring the right column forward.
export const FOCUS_COMPOSE_EVENT = 'whocare:focus-compose';
export const FOCUS_SEARCH_EVENT = 'whocare:focus-search';
